import React from 'react';
import '../styles/Solutions.css';

const Solutions = () => {
  const solutions = [
    {
      icon: 'fa fa-university',
      title: 'Educesol',
      description: 'MetroBlue Educesol is a unique and robust solution designed to suit the needs of any institution of learning. It includes students database, faster result computation, e-learning integration, CBT integration...',
      link: 'https://metroblue.com.ng/educesol'
    },
    {
      icon: 'fa fa-briefcase',
      title: 'Enterprise',
      description: 'MetroBlue Enterprise is another unique solution designed to suit the needs of any business organisation. It includes branding and re-branding, business website, digital marketing, business solution software...',
      link: 'https://metroblue.com.ng/enterprise'
    },
    {
      icon: 'fa fa-wallet',
      title: 'Metroblits',
      description: 'Metroblits is a platform powered by MetroBlue which incorporates various forms of digital solutions basically at wholesale prices. At metroblits, resellers can sell the airtime, data, pay bills, send bulk SMS...',
      link: 'https://metroblue.com.ng/metroblits'
    },
    {
      icon: 'fa fa-fingerprint',
      title: 'Custom Solutions',
      description: 'MetroBlue Custom solutions is designed to meet the unique needs of corporate organisations including businesses, learning institutions, NGOs, government parastatals etc., private individuals, religious organisations ...',
      link: 'https://metroblue.com.ng/customsolutions'
    }
  ];

  return (
    <div className="feature-area section-padding" id="feature">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 text-center">
            <h2 className="section-title" style={{color: '#fff'}}>Our Solutions</h2>
            <div className="sub-heading">
              <p className="section-subtitle" style={{color: '#fff'}}>
                Have a look at some of our unique solutions geared at making<br />
                your business or institutional operations more productive
              </p>
            </div>
          </div>
        </div>

        <div className="row solutions-grid">
          {solutions.map((solution, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12">
              <div className="solution-card">
                <div className="solution-icon">
                  <i className={solution.icon}></i>
                </div>
                <h3>{solution.title}</h3>
                <p>{solution.description}</p>
                <a href={solution.link} className="solution-link">Learn more...</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Solutions;  